export default __webpack_public_path__ + "static/media/ic-close.685178ac.svg";